import React from 'react';
import { MapContainer, TileLayer, Marker, Tooltip } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { useTranslation } from 'react-i18next';
import {
  COMPANY,
  MAP_POSITION,
  getGoogleMapsDirectionsUrl,
  getGoogleMapsSearchUrl,
} from '../legal/companyInfo';

const clinicIcon = L.divIcon({
  className: 'clinic-map-marker',
  html: '<span aria-hidden="true"></span>',
  iconSize: [22, 22],
  iconAnchor: [11, 11],
});

const openGoogleMaps = () => {
  window.open(getGoogleMapsSearchUrl(), '_blank', 'noopener,noreferrer');
};

const MapLocationInfo = ({ t }) => (
  <div className="map-location">
    <h1>{t('map.localizacion')}</h1>
    <div className="mapContent">
      <div className="mapSection">
        <h2>{t('map.direccion')}</h2>
        <p>{COMPANY.shortAddress}</p>
        <a
          className="map-directions-link"
          href={getGoogleMapsDirectionsUrl()}
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('map.abrirEnGoogle')}
        </a>
      </div>
      <div className="mapSection">
        <h2>{t('map.horario')}</h2>
        <h3>{t('map.dias')}</h3>
        <p>9:30 a 20:00 H</p>
        <h3>{t('map.dias2')}</h3>
        <p>9:30 a 13:30 H</p>
      </div>
    </div>
  </div>
);

const ClinicMap = ({ showLocationInfo = true }) => {
  const { t } = useTranslation('global');

  return (
    <div className="map">
      <div id="myMap" className="clinic-leaflet-map">
        <MapContainer
          center={MAP_POSITION}
          zoom={16}
          scrollWheelZoom={false}
          attributionControl
          style={{ width: '100%', height: '100%', minHeight: '100%' }}
        >
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <Marker
            position={MAP_POSITION}
            icon={clinicIcon}
            eventHandlers={{ click: openGoogleMaps }}
          >
            <Tooltip direction="top" offset={[0, -8]} opacity={0.95}>
              {t('map.clickMarker')}
            </Tooltip>
          </Marker>
        </MapContainer>
      </div>
      {showLocationInfo && <MapLocationInfo t={t} />}
    </div>
  );
};

export default ClinicMap;

